import { v4 as uuid } from 'uuid'

import { FormBuilderPage } from '../domain/FormBuilder/FormBuilderPage'
import FormBuilderRow from '../domain/FormBuilder/FormBuilderRow'
import FormBuilderSection from '../domain/FormBuilder/FormBuilderSection'

export const FORM_NAME_ERROR_MESSAGE = 'Please enter the form name'

export const SELECTION_TYPE = {
  FORM: 'form',
  PAGE: 'page',
  QUESTION: 'question',
  QUESTION_ADD: 'question_add',
  ROW_ADD: 'row_add',
  SECTION: 'section',
  SETTINGS: 'settings',
}

function buildIds() {
  return {
    FORM: uuid(),
    PAGE: uuid(),
    SECTION: uuid(),
    ROW: uuid(),
    QUESTION: uuid(),
  }
}

const buildInitialEmptyForm = () => {
  const ID = buildIds()
  return {
    PAGE: {
      [ID.PAGE]: new FormBuilderPage({
        formId: ID.FORM,
        id: ID.PAGE,
        allow_empty: false,
      }),
    },
    SECTION: {
      [ID.SECTION]: new FormBuilderSection({
        id: ID.SECTION,
        page: ID.PAGE,
      }),
    },
    ROW: {
      [ID.ROW]: new FormBuilderRow({
        id: ID.ROW,
        section: ID.SECTION,
        order: 0,
      }),
    },
    QUESTION: {
      // [ID.QUESTION]: new FormBuilderQuestion({
      //   id: ID.QUESTION,
      //   section: ID.SECTION,
      //   row: ID.ROW,
      // }),
    },
  }
}

export const CONSTANTS_FORM_BUILDER = {
  SELECTION_TYPE,
  INITIAL_EMPTY_FORM: buildInitialEmptyForm,
}
